export const SET_HEADING = "SET_HEADING";
export const SET_EDIT = "SET_EDIT";
export const LOADING = "LOADING";
export const SET_ROUTING = "SET_ROUTING";

//---------------Customer Service App------------------------
export const GET_DETAILS_BY_MOBILENUMBER_SUCCESS = "GET_DETAILS_BY_MOBILENUMBER_SUCCESS"; 
export const GET_DETAILS_BY_MOBILENUMBER_FAILURE = "GET_DETAILS_BY_MOBILENUMBER_FAILURE"; 

//--------------------------CUSTOMER---------------------------
export const GET_CUSTOMER_BY_CIF_ID_SUCCESS = "GET_CUSTOMER_BY_CIF_ID_SUCCESS";
export const GET_CUSTOMER_BY_CIF_ID_FAILURE = "GET_CUSTOMER_BY_CIF_ID_FAILURE";

//--------------------------ENACH----------------------------
export const GET_ENACH_SUCCESS = "GET_ENACH_SUCCESS";
export const GET_ENACH_FAILURE = "GET_ENACH_FAILURE"; 

export const SAVE_ENACH_SUCCESS = "SAVE_ENACH_SUCCESS";
export const SAVE_ENACH_FAILURE = "SAVE_ENACH_FAILURE";

//--------------------------LOAN------------------------------
export const GET_LOAN_BY_ID_SUCCESS = "GET_LOAN_BY_ID_SUCCESS";
export const GET_LOAN_BY_ID_FAILURE = "GET_LOAN_BY_ID_FAILURE";

export const GET_CUSTOMER_SEARCH_SUCCESS = "GET_CUSTOMER_SEARCH_SUCCESS";
export const GET_CUSTOMER_SEARCH_FAILURE = "GET_CUSTOMER_SEARCH_FAILURE";

//---------------------------BIKE SERVICE-----------------------
export const SAVE_BIKE_SERVICE_SUCCESS = "SAVE_BIKE_SERVICE_SUCCESS";
export const SAVE_BIKE_SERVICE_FAILURE = "SAVE_BIKE_SERVICE_FAILURE";

//-----------------------------REQUEST-----------------------------
export const SAVE_REQUEST_SUCCESS = "SAVE_REQUEST_SUCCESS";
export const SAVE_REQUEST_FAILURE = "SAVE_REQUEST_FAILURE";

//-----------------------------RAZOR PAY--------------------------
export const GET_RAZORPAY_DETAILS_SUCCESS = "GET_RAZORPAY_DETAILS_SUCCESS";
export const GET_RAZORPAY_DETAILS_FAILURE = "GET_RAZORPAY_DETAILS_FALIURE";

export const SAVE_RAZORPAY_DETAILS_SUCCESS = "SAVE_RAZORPAY_DETAILS_SUCCESS";
export const SAVE_RAZORPAY_DETAILS_FAILURE = "SAVE_RAZORPAY_DETAILS_FALIURE";

export const GET_RECEIPT_BY_PAYMENT_DETAILS_SUCCESS = "GET_RECEIPT_BY_PAYMENT_DETAILS_SUCCESS";
export const GET_RECEIPT_BY_PAYMENT_DETAILS_FAILURE = "GET_RECEIPT_BY_PAYMENT_DETAILS_FALIURE";

export const GET_RECEIPT_NUMBER_SUCCESS = "GET_RECEIPT_NUMBER_SUCCESS";
export const GET_RECEIPT_NUMBER_FAILURE = "GET_RECEIPT_NUMBER_FALIURE";

//------------------------------UPLOAD PROFILE----------------------
export const UPLOAD_PROFILE_SUCCESS = "UPLOAD_PROFILE_SUCCESS";
export const UPLOAD_PROFILE_FAILURE = "UPLOAD_PROFILE_FALIURE";

export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE";

//------------------------------VEHICLE LIST------------------------
export const GET_ALL_VEHICLE_LIST_SUCCESS = "GET_ALL_VEHICLE_LIST_SUCCESS";
export const GET_ALL_VEHICLE_LIST_FAILURE = "GET_ALL_VEHICLE_LIST_FAILURE";

// -------------------------carisel Images----------------------

export const GET_CAROUSEL_IMAGES = "GET_CAROUSEL_IMAGES";
export const GET_CAROUSEL_IMAGES_SUCCESS = "GET_CAROUSEL_IMAGES_SUCCESS";
export const GET_CAROUSEL_IMAGES_FAILURE = "GET_CAROUSEL_IMAGES_FAILURE";


// --------------------------get-FAQ list-------------------------
export const GET_FAQ_LIST_SUCCESS = "GET_FAQ_LIST_SUCCESS";
export const GET_FAQ_LIST_FAILURE = "GET_FAQ_LIST_FAILURE";

//----------------------------BNPL Card---------------------------
export const BNPL_CREATE_APPLICANT_SUCCESS = "BNPL_CREATE_APPLICANT_SUCCESS";
export const BNPL_CREATE_APPLICANT_FAILURE = "BNPL_CREATE_APPLICANT_FAILURE";

export const BNPL_SUBMIT_APPLICANT_SUCCESS = "BNPL_SUBMIT_APPLICANT_SUCCESS";
export const BNPL_SUBMIT_APPLICANT_FAILURE = "BNPL_SUBMIT_APPLICANT_FAILURE";

export const GET_LOS_DATA_BY_LOANID_SUCCESS = "GET_LOS_DATA_BY_LOANID_SUCCESS";
export const GET_LOS_DATA_BY_LOANID_FAILURE = "GET_LOS_DATA_BY_LOANID_FAILURE";

export const BNPL_CREATE_CUSTOMER_SUCCESS = "BNPL_CREATE_CUSTOMER_SUCCESS";
export const BNPL_CREATE_CUSTOMER_FAILURE = "BNPL_CREATE_CUSTOMER_FAILURE";

export const BNPL_CREATE_PAYLATER_ACCOUNT_SUCCESS =
  "BNPL_CREATE_PAYLATER_ACCOUNT_SUCCESS";
export const BNPL_CREATE_PAYLATER_ACCOUNT_FAILURE =
  "BNPL_CREATE_PAYLATER_ACCOUNT_FAILURE";

export const GENERATE_OTP_SUCCESS = "GENERATE_OTP_SUCCESS";
export const GENERATE_OTP_FAILURE = "GENERATE_OTP_FAILURE";

export const CREATE_CARD_SUCCESS = "CREATE_CARD_SUCCESS";
export const CREATE_CARD_FAILURE = "CREATE_CARD_FAILURE";

export const SESSION_TOKEN_SUCCESS = "SESSION_TOKEN_SUCCESS";
export const SESSION_TOKEN_FAILURE = "SESSION_TOKEN_FAILURE";

export const TERMS_CONDITION_SUCCESS = "TERMS_CONDITION_SUCCESS";
export const TERMS_CONDITION_FAILURE = "TERMS_CONDITION_FAILURE";

export const APPLICATION_CREATED_FLAG_SUCCESS = "APPLICATION_CREATED_FLAG_SUCCESS";
export const APPLICATION_CREATED_FLAG_FAILURE = "APPLICATION_CREATED_FLAG_FAILURE";

// ------------------crif api for breau score----------------/

export const CRIF_SCRORE_SUCCESS = "CRIF_SCRORE_SUCCESS";
export const CRIF_SCRORE_FAILURE = "CRIF_SCRORE_FAILURE";

export const CRIF_SCRORE_GET_SUCCESS = "CRIF_SCRORE_GET_SUCCESS";
export const CRIF_SCRORE_GET_FAILURE = "CRIF_SCRORE_GET_FAILURE";

export const CRIF_SCRORE_SAVE_SUCCESS = "CRIF_SCRORE_SAVE_SUCCESS";
export const CRIF_SCRORE_SAVE_FAILURE = "CRIF_SCRORE_SAVE_FAILURE";

// ------------------City list----------------/
export const GET_CITY_LIST_SUCCESS = "GET_CITY_LIST_SUCCESS";
export const GET_CITY_LIST_FAILURE = "GET_CITY_LIST_FAILURE";

// ------------------vehicle brands list----------------/
export const GET_VEHICLE_BRAND_LIST_SUCCESS = "GET_VEHICLE_BRAND_LIST_SUCCESS";
export const GET_VEHICLE_BRAND_LIST_FAILURE = "GET_VEHICLE_BRAND_LIST_FAILURE";

// ------------------vehicle model list----------------/
export const GET_VEHICLE_MODEL_LIST_SUCCESS = "GET_VEHICLE_MODEL_LIST_SUCCESS";
export const GET_VEHICLE_MODEL_LIST_FAILURE = "GET_VEHICLE_MODEL_LIST_FAILURE";

// ------------------vehicle submodel list----------------/
export const GET_VEHICLE_SUBMODEL_LIST_SUCCESS = "GET_VEHICLE_SUBMODEL_LIST_SUCCESS";
export const GET_VEHICLE_SUBMODEL_LIST_FAILURE = "GET_VEHICLE_SUBMODEL_LIST_FAILURE";

// ------------------vehicle details----------------/
export const GET_VEHICLE_DETAILS_SUCCESS = "GET_VEHICLE_DETAILS_SUCCESS";
export const GET_VEHICLE_DETAILS_FAILURE = "GET_VEHICLE_DETAILS_FAILURE";

// ------------------customer details----------------/
export const GET_CUSTOMER_DETAILS_SUCCESS = "GET_CUSTOMER_DETAILS_SUCCESS";
export const GET_CUSTOMER_DETAILS_FAILURE = "GET_CUSTOMER_DETAILS_FAILURE";

// ------------------save customer details----------------/
export const SAVE_CUSTOMER_DETAILS_SUCCESS = "SAVE_CUSTOMER_DETAILS_SUCCESS";
export const SAVE_CUSTOMER_DETAILS_FAILURE = "SAVE_CUSTOMER_DETAILS_FAILURE";

// ------------------save customer details----------------/
export const GET_LEAD_SUCCESS = "GET_LEAD_SUCCESS";
export const GET_LEAD_FAILURE = "GET_LEAD_FAILURE";

// ------------------save customer details----------------/
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_FAILURE = "GET_STATE_FAILURE";

// ------------------get jobsType by profession----------------/
export const GET_JOBTYPES_SUCCESS = "GET_JOBTYPES_SUCCESS";
export const GET_JOBTYPES_FAILURE = "GET_JOBTYPES_FAILURE";

// ------------------post pancard image----------------/
export const POST_PANCARD_SUCCESS = "POST_PANCARD_SUCCESS";
export const POST_PANCARD_FAILURE = "POST_PANCARD_FAILURE";

// ------------------verify pancard details----------------/
export const VERIFY_PANCARD_SUCCESS = "VERIFY_PANCARD_SUCCESS";
export const VERIFY_PANCARD_FAILURE = "VERIFY_PANCARD_FAILURE";
